export default {
  /* Global */
  // 用户信息
  USER_INFO: 'USER_INFO',

  /* Statistics */
  // 系统列表
  SYSTEM_LIST: 'SYSTEM_LIST',

  // 用户权限
  USER_PRIVILEGE: 'USER_PRIVILEGE'
}
